/* eslint-disable react-hooks/exhaustive-deps */
import { MouseEvent, useEffect, useRef } from "react"
import { ISectionMarkingProps } from "./SectionMarking"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILandingConsoleStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { DEFAULT_SECTION_PADDING, HISTORY_TYPE, ILanding, ILandingSection, LANDING_EDIT_MODE } from "src/modules/pe-landing-module/data/interfaces"
import { Button, Icon, NumericInput, Popover, PopoverInteractionKind, Position, Size, Tooltip } from "@blueprintjs/core" 
import { __ } from "src/libs/utilities"
import useClickOutside from "src/modules/pe-fest-module/widgets/hooks/useClickOutside"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import updateSection from "./utils/updateSection"

/* Protopia Ecosystem component */
export interface ISectionTopPaddingHandlerProps extends ISectionMarkingProps {
    
}
const SectionBottomPaddingHandler = (props: ISectionTopPaddingHandlerProps): JSX.Element => {
    const settings      = useLandingConsoleStore((state:ILandingConsoleStore) => state.settings )
    const currentDimensionEdit:  WINDOW_WIDTH   = useLandingConsoleStore((state:ILandingConsoleStore) => state.currentDimensionEdit)
    const {position, }  = usePosition( props.section ) 
    const sizes     = useScreenSize()
    const ref       = useRef( null )
    const y         = useSyncState<number>( 0 )
    const startDragY= useSyncState<number>( 0 ) 
    const preY      = useSyncState<number>( 0 ) 
    const bounds    = useSyncState<DOMRect>({} as DOMRect)
    const ctrlKey   = useSyncState<boolean>( false ) 
    const isOpen    = useSyncState<boolean>( false ) 

    useEffect(() => {
        if(  props.section.isHidden || !(settings.linesAndHandlers && settings.sectionPaddings) ||  sizes.width < WINDOW_WIDTH.TABLET) return 
        //дожидаемся изменения размеров, они происходят с задержкой
        setTimeout(() => {
            bounds.set( (ref.current! as Element).closest(".landing-section-container")!.getBoundingClientRect() )
            const yy = typeof props.section.paddingBottom !== "undefined" 
                ?  
                bounds.get().height - props.section.paddingBottom
                : 
                bounds.get().height - DEFAULT_SECTION_PADDING
            y.set(yy)
            preY.set( bounds.get().height - y.get() )
        }, 100) 
    }, [ props.section, currentDimensionEdit, settings.linesAndHandlers, settings.sectionPaddings, position ])

    const onDragStart = (evt: MouseEvent) => {
        ctrlKey.set(evt.ctrlKey);
        (evt as any).dataTransfer.setDragImage(evt.target, window.outerWidth, window.outerHeight);
        startDragY.set( evt.clientY - y.get() )
        const sectionEdit = document.querySelectorAll(".landing-section-edit-form")
        sectionEdit.forEach( s  => (s as HTMLDivElement).style.visibility = "hidden")
        evt.stopPropagation()
    }
    const onDrag = (evt: MouseEvent) => {
        ctrlKey.set(evt.ctrlKey)
        const y1 = evt.clientY - startDragY.get()
        const yy = Math.round(y1 / 5) * 5 
        if( yy <= bounds.get().height ) {
            y.set( yy )
        }
        evt.stopPropagation()
    }
    const onDragEnd = (evt: MouseEvent) => {
        const y1 = evt.clientY - startDragY.get()
        const yy = Math.round(y1 / 5) * 5 
        if( yy <= bounds.get().height ) {
            y.set( yy )
            const currentLanding: ILanding = { ...useLandingStore.getState().currentLanding }
            const newY      = Math.round( (bounds.get().height - yy) / 5 ) * 5 
            const section = currentLanding.sections[ props.i ] 
            const newVal = JSON.parse(JSON.stringify( {
                ...section,
                paddingBottom: newY,
                paddingTop: ctrlKey.get() ? newY : section.paddingTop
            }))
            updateSection( 
                newVal,
                {
                    data: newVal,
                    prevData: section,
                    type: HISTORY_TYPE.SECTION,
                    title: "Change section's bottom padding"
                } 
            )
            /*
            const newVal    = {
                currentLanding: {
                    ...currentLanding,
                    sections: currentLanding.sections.map((section: ILandingSection, i) => {
                        if(i === props.i) {
                            return {
                                ...section,
                                paddingBottom: newY,
                                paddingTop: ctrlKey.get() ? newY : section.paddingTop
                            }
                        }
                        return section
                    })
                },
                needUpdate: true
            } 
            useLandingStore.setState(newVal)
            */
        }
        const sectionEdit = document.querySelectorAll(".landing-section-edit-form")
        sectionEdit.forEach(s => (s as HTMLDivElement).style.visibility = "visible")
        evt.stopPropagation()
        ctrlKey.set( false )
    }

    const onChange = (value: number) => { 
        preY.set( value )  
    }
    const onChangeY = () => {
        set_Y( preY.get() )
        onClose()
    }
    const onClose = () => {
        isOpen.set( false )
    }
    const set_Y = (value: number) => {
        const currentLanding: ILanding = { ...useLandingStore.getState().currentLanding }
        const section = currentLanding.sections[ props.i ] 
        const newVal = JSON.parse(JSON.stringify( {
            ...section,
            paddingBottom: value, 
        }))
        updateSection( 
            newVal,
            {
                data: newVal,
                prevData: section,
                type: HISTORY_TYPE.SECTION,
                title: "Change section's bottom padding"
            } 
        )
        /*
        const newVal = {
            currentLanding: {
                ...currentLanding,
                sections: currentLanding.sections.map((section: ILandingSection, i) => {
                    if(i === props.i) {
                        return {
                            ...section,
                            paddingBottom: value
                        }
                    }
                    return section
                })
            },
            needUpdate: true
        } 
        useLandingStore.setState(newVal)
        */
    }

    const bottomY = Math.floor(bounds.get().height - y.get())  
    return  props.section.isHidden || !(settings.linesAndHandlers && settings.sectionPaddings) ||  sizes.width < WINDOW_WIDTH.TABLET
        ?
        <></>
        :
        <>
                <div 
                    className='landing-section-bottom-padding-handler pe-surface'
                    style={{
                        top: y.get(),
                    }}
                    ref={ ref }
                    draggable
                    onDragStart={onDragStart}
                    onDrag={onDrag}
                    onDragEnd={onDragEnd}
                >
                    <span className="landing-section-p pl-1">
                        <div className="pr-1">
                            { isNaN(bottomY) ? DEFAULT_SECTION_PADDING : bottomY }
                        </div>
                        <Popover 
                            position={ Position.TOP_LEFT } 
                            interactionKind={ PopoverInteractionKind.CLICK }
                            isOpen={ isOpen.get() }
                            content={ <YHandler 
                                preY={ preY.get() }
                                y={ bottomY }
                                onChange={ onChange } 
                                onChangeY={ onChangeY }
                                onClose={ onClose }        
                            />} 
                            className=""
                        >
                            <Tooltip position={ Position.TOP_LEFT } content={<div className="small letter-spacing-1">{ __( "Edit" ) }</div>} className="pr-1 pb-1">
                                <Icon icon="edit" size={ 8 } color="#FFFFFF" className="pointer" onClick={ () => isOpen.set( !isOpen.get() ) } />
                            </Tooltip>
                        </Popover>
                    </span>
                </div>    
            </>
}
export default SectionBottomPaddingHandler



export const YHandler = (props: any) : JSX.Element => {
    const ref = useRef( null) 
    useClickOutside(ref, props.onClose) 
    return <div className="p-2 d-flex" ref={ref}>
        <NumericInput onValueChange={ props.onChange } value={ props.preY } size={Size.SMALL} />
        <Button 
            onClick={props.onChangeY} 
            icon={ props.preY === props.y  ? "blank" : "tick" }  
            size={Size.SMALL} 
            variant="minimal"
        />
        <Button 
            onClick={props.onClose}   
            icon="cross" 
            size={Size.SMALL} 
            variant="minimal"
        />
    </div>
}